import { Fragment } from "react";
import { observer } from 'mobx-react'
import { makeStyles, Theme, createStyles, Container, Paper } from "@material-ui/core";
import { FlowRunner } from "../../components/FlowRunner";
import Footer from "../../../../components/Shared/Footer";
import { OrganizationSignUpFlowDefinition } from "../data/OrganizationSignUpFlowDefinition";

const useStyles = makeStyles((theme: Theme) =>
    createStyles({
        root: {
            paddingTop: theme.spacing(3),
            paddingBottom: theme.spacing(3),
            flexGrow: 1
        },
        content: {
            [theme.breakpoints.down('xs')]: {
                padding: theme.spacing(2)
            },
            marginBottom: theme.spacing(3),
            padding: theme.spacing(3)
        },
    })
);

const OrganizationSignUpFlow = observer(() => {

    /********* React hooks *********/

    const classes = useStyles();

    /********* Render *********/

    return (
        <Fragment>
            <div className={classes.root}>
                <Container>
                    <Paper className={classes.content}>
                        <FlowRunner flow={OrganizationSignUpFlowDefinition} />
                    </Paper>
                </Container>
            </div>
            <Footer />
        </Fragment >
    );
});

export default OrganizationSignUpFlow;